import { connect } from 'react-redux'
import { Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, Row } from 'reactstrap'
import { getMembers_action, toggleInviteTeammates_action } from 'store/actions'
import { ReactComponent as TrashIcon } from 'assets/images/icons/trash_2.svg'
import { Field, FieldArray, Formik } from 'formik'
import { handleApiError, logAmplitudeEvent } from 'utils/helpers'
import * as yup from 'yup'
import { inviteUsers_api } from 'store/apis'
import { toast } from 'react-toastify'
import { ModalForm } from 'modules/app/styles'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { CustomButton } from 'modules/auth/styles'
import { ButtonLoader } from 'utils/storageUtils'
import { RemoveInviteEmail } from 'modules/settings/styles'
import { Fragment, useState } from 'react'
import { history } from 'store/store'

const InviteTeammateModal = (props) => {
  const [is_submitting, set_is_submitting] = useState(false)
  const [saved, set_saved] = useState(false)
  const closeModal = (e) => {
    e && e.preventDefault()
    history.replace('/')
    props.toggleInviteTeammates(false)
  }
  return (
    <Modal zIndex={props.fullScreenStatus ? '3000000000' : '1051'} isOpen centered fade={false} toggle={closeModal}>
      <Formik
        enableReinitialize
        validateOnBlur={false}
        initialValues={{
          members: [{ name: '', email: '', user_type: 'member', position: '' }],
          invite_message: `${props.user.name} is inviting you to join their party!\nVenue: ${props.company.name} Klutch Base.\nJoin now and never miss a beat. Stay updated with everything ${props.company.name} by joining their Base now.`
        }}
        validationSchema={yup.object().shape({
          members: yup.array().of(
            yup.object().shape({
              email: yup.string().email('Invalid Email').required(),
              user_type: yup.string().required()
            })
          )
        })}
        onSubmit={async (fields) => {
          try {
            set_is_submitting(true)
            const data = { ...fields, members: JSON.stringify(fields.members) }
            const response = await inviteUsers_api(data)
            logAmplitudeEvent('Invited teammates', { members: fields.members })
            toast.success(response.message)
            set_is_submitting(false)
            props.toggleInviteTeammates(false)
            set_saved(true)
            setTimeout(() => set_saved(false), 1000)
            props.getMembers()
          } catch (error) {
            handleApiError(error)
            set_is_submitting(false)
          }
        }}>
        {(formikProps) => (
          <ModalForm onSubmit={formikProps.handleSubmit} autoComplete='off'>
            <ModalBody>
              <a href='/' className='modal-close' onClick={closeModal}>
                <CloseIcon />
              </a>
              <div className='title'> Invite Teammates </div>
              <FieldArray
                name='members'
                render={(arrayhelpers) => (
                  <div className='mt-5'>
                    {formikProps.values['members'].map((member, index) => (
                      <Row key={index} className='align-items-center'>
                        <Col>
                          <FormGroup style={{ marginBottom: '2rem' }}>
                            <Field name={`members.${index}.email`}>
                              {({ field, meta }) => (
                                <Fragment>
                                  <Input
                                    type='text'
                                    id={`email_${index}`}
                                    {...field}
                                    autoFocus
                                    className={`invite-member ${field.value ? 'has-value' : ''} ${meta.touched && meta.error ? 'error' : ''}`}
                                  />
                                  <Label className='text-secondary' htmlFor={`email_${index}`}>
                                    Email
                                  </Label>
                                  {formikProps.values.members.length > 1 && (
                                    <RemoveInviteEmail
                                      href='/'
                                      onClick={(e) => {
                                        e.preventDefault()
                                        arrayhelpers.remove(index)
                                      }}>
                                      <TrashIcon />
                                    </RemoveInviteEmail>
                                  )}
                                </Fragment>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col>
                          <div className='d-flex align-items-start'>
                            <Field name={`members.${index}.user_type`}>
                              {({ field }) => (
                                <FormGroup check className='d-flex align-items-center px-0' style={{ marginBottom: '20px' }}>
                                  <Label check className='mr-4'>
                                    <Input
                                      type='radio'
                                      name={`members.${index}.user_type`}
                                      checked={field.value === 'admin'}
                                      value='admin'
                                      onChange={(e) => formikProps.setFieldValue(`members.${index}.user_type`, e.target.value)}
                                    />
                                    <span>Admin</span>
                                  </Label>
                                  <Label check>
                                    <Input
                                      type='radio'
                                      name={`members.${index}.user_type`}
                                      checked={field.value === 'member'}
                                      value='member'
                                      onChange={(e) => formikProps.setFieldValue(`members.${index}.user_type`, e.target.value)}
                                    />
                                    <span>Member</span>
                                  </Label>
                                </FormGroup>
                              )}
                            </Field>
                          </div>
                        </Col>
                      </Row>
                    ))}
                    <FormGroup>
                      <CustomButton
                        type='button'
                        className='gray btn-sm'
                        disabled={!formikProps.isValid}
                        onClick={() => {
                          arrayhelpers.insert(formikProps.values.members.length, { name: '', email: '', user_type: 'member', position: '' })
                        }}>
                        Add More
                      </CustomButton>
                    </FormGroup>
                  </div>
                )}
              />
              <Field name='invite_message'>
                {({ field }) => (
                  <div className='mt-4'>
                    <Input type='textarea' rows={4} {...field} placeholder='Write your custom message here' />
                  </div>
                )}
              </Field>
            </ModalBody>
            <ModalFooter className='d-flex justify-content-center'>
              <CustomButton type='button' onClick={() => formikProps.submitForm()} className={`mx-5 ${!saved ? 'black' : 'green'}`} disabled={is_submitting || saved}>
                {saved ? 'Invitation Sent' : props.isFree || props.isOnGracePeriod || props.subscription.is_subscribed ? 'Confirm and Invite' : 'Invite Teammate'} {is_submitting && <ButtonLoader />}
              </CustomButton>
              <a href='/' className='text-dark font-weight-600' onClick={closeModal}>
                Cancel
              </a>
            </ModalFooter>
          </ModalForm>
        )}
      </Formik>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  app: state.app,
  subscription: state.subscription,
  user: state.auth.user,
  company: state.company.company,
  isFree: state.company.company.isFree,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  fullScreenStatus: state.contents.isFullScreen
})

const mapDispatchToProps = (dispatch) => ({
  toggleInviteTeammates: (status) => dispatch(toggleInviteTeammates_action(status)),
  getMembers: () => dispatch(getMembers_action())
})
export default connect(mapStateToProps, mapDispatchToProps)(InviteTeammateModal)
